<template>
    <el-footer class="soulexe-footer">
        <el-row :gutter="10">
            <el-col :span="12">
                <div class="footer-contact" >
                    <div class="footer-logo">
                        <img src="@/assets/img/soulexe_w.png" />
                    </div>
                    <div class="contact-list">
                        <div class="contact-item">
                            <el-icon :size="15" class="contact-icon">
                                <Message />
                            </el-icon>
                            <a class="contact-content" href="mailto:service@soulexe.com">service@soulexe.com</a>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="footer-quicklink">
                    <div class="qlink-title">关于我们</div>
                    <div class="qlink">
                        <a href="https://soulexe.com" target="_blank">soulexe官网</a>
                    </div>
                    <div class="qlink">
                        <a href="https://n.soulexe.com" target="_blank">soulexe手办</a>
                    </div>

                </div>
            </el-col>
        </el-row>
        <div class="beian">
            ©索异科技（深圳）有限公司 2025 版权所有
            <br>
            <a href="https://beian.miit.gov.cn">粤ICP备2023097332号</a>
        </div>
    </el-footer>
</template>

<script >
export default {
    name: "FooterBar",
    components: {}
};
</script>

<style lang="scss">
.soulexe-footer{
    padding-top: 30px;
    padding-bottom: 20px;
    background: var(--gray-color7);
    margin-top:30px;
    text-align: center;
    bottom: 0;
    height:auto;
    font-size:9px;
    a {
        text-decoration: none;
    }
}
.flex-grow {
    flex-grow: 1;
}
.beian {
    border-top: 1px var(--gray-color6) solid;
    color: var(--gray-color6);
    padding-top: 30px;
    margin-top: 30px;
    a {
        color: var(--gray-color6);
        line-height: 2em;
    }
}
.footer-contact{
    color: var(--gray-color3);
    margin-bottom: 30px;
    .contact-list {
        margin-top: 20px;
    }
    .contact-icon{
        line-height: 15px;
        margin-right:0.5em;
        vertical-align: text-bottom;
    }
    .contact-content {
        font-size: 16px;
        color: var(--gray-color3);

    }
    .contact-content:hover{
        text-shadow: var(--gray-color0) 0 0 2px;
    }
    .footer-logo{
        img {
            width: 30%;
            max-width: 100px;
        }
    }
}
.footer-quicklink{
    color: var(--gray-color1);
    font-size: 16px;
    .qlink-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 1em;
        cursor: default;
    }
    .qlink{
        line-height: 2em;
        a {
            color: var(--gray-color4);
        }
        a:hover{
            text-shadow: var(--gray-color1) 0 0 2px;
        }
    }
}
</style>